import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import CurrencyInput from 'react-currency-input';
import {PowerSelect} from 'react-power-select';
import 'react-power-select/dist/react-power-select.css';
import CompaniesDropdown from '../companies/companies-dropdown.jsx';

export default class AddNewSubcontractor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      companies: props.companiesAll || [],
      selectedCustomerId: null,
    };
    this.handleAddNewSubcontractorCreate = this.handleAddNewSubcontractorCreate.bind(this);
    this.handleCustomerSelection = this.handleCustomerSelection.bind(this);
  }

  handleCustomerSelection(option) {
    this.setState({selectedCustomerId: option.id});
  }
  
  handleAddNewSubcontractorCreate(e) {
    e.preventDefault();
    let newSubcontractorData = {
      api_token: window.api_token,
      company_id:  $('[name=company-id]').val(),
      home_address: {
        postcode: $('[name=home_address_postcode]').val(),
        house_number_or_name: $('[name=home_address_house_number_or_name]').val(),
        address_line_1: $('[name=home_address_address_line_1]').val(),
        address_line_2: $('[name=home_address_address_line_2]').val(),
        address_line_3: $('[name=home_address_address_line_3]').val(),
        town_city: $('[name=home_address_town_city]').val(),
        county_area: $('[name=home_address_county_area]').val(),
        country: $('[name=home_address_country]').val(),
      },
      subcontractor_first_name: $('[name=subcontractor_first_name]').val(),
      subcontractor_last_name: $('[name=subcontractor_last_name]').val(),
      subcontractor_email:$('[name=subcontractor_email]').val(),
      subcontractor_password:$('[name=subcontractor_password]').val(),
      contact_number_1: $('[name=contact_number_1]').val(),
      contact_number_2: $('[name=contact_number_2]').val(),
      subcontractor_po_number:$('[name=subcontractor_po_number]:checked').val(),
      subcontractor_access_to_g4:$('[name=subcontractor_access_to_g4]:checked').val(),
      payment_terms:$('[name=payment_terms]').val(),
    }

    $.ajax({
      type: "POST",
      url: '/api/v1/portal/subcontractors/add-new-subcontractor',
      data: newSubcontractorData,
      dataType: "text/json",
      complete: function(response) {
        if (response.status == 200) {
          $('#infomodallabel').html('New Subcontractor Created');
          $('#infomodal .modal-body').html('New Subcontractor Created');
          $('#infomodal').modal();
          $('input').val('');
          $('textarea').val('');
        }
        else {
          $('#infomodallabel').html('Error adding new Subcontractor');
          $('#infomodal .modal-body').html($.parseHTML(response.responseText.replace(/\"/g, "")));
          $('#infomodal').modal();
        }
      }
    });
  }

  toggleAddNewDriver(e) {
    $('#add_new_driver_form').slideToggle();
    $('.add-new-driver-button').toggleClass('text-center').toggleClass('opened-button-for-slidedown-content');
    $('#slide-toggle-icon').toggleClass('fa-minus-circle');
    $('#react-component-g4-logistics-portal-add-new-subcontractor').toggleClass('active');
  }


  render() {
    return (
      <div>
        <button className="text-center btn btn-lg btn-light add-new-driver-button"
                type="button" onClick={this.toggleAddNewDriver}>
          <i className="fa fa-plus-circle" id="slide-toggle-icon"></i>&nbsp;
          Add New Subcontractor
        </button>

        <form id="add_new_driver_form" ref="addNewDriverForm">
          <fieldset>
            <br />
            <br />
            <h1>Add New Subcontractor</h1>
            <br />

            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Company</label>
                  <CompaniesDropdown />
                </div>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <label htmlFor="subcontractor_first_name">Subcontractor First Name</label>
                      <input type="text" name="subcontractor_first_name" id="subcontractor_first_name"
                             className="form-control form-control-lg" />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="subcontractor_last_name">Subcontractor Last Name</label>
                      <input type="text" name="subcontractor_last_name" id="subcontractor_last_name"
                             className="form-control form-control-lg" />
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col-md-6">
                      <label htmlFor="subcontractor_email">Subcontractor Email</label>
                      <input type="text" name="subcontractor_email" id="subcontractor_email"
                             className="form-control form-control-lg" />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="subcontractor_password">Subcontractor Password</label>
                      <input type="password" name="subcontractor_password" id="subcontractor_password"
                             className="form-control form-control-lg" />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="contact_number_1">Subcontractor Contact Phone Number 1</label>
                      <input type="text" className="form-control form-control-lg"
                             name="contact_number_1" id="contact_number_1" required />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="contact_number_2">Subcontractor Contact Phone Number 2</label>
                      <input type="text" className="form-control form-control-lg"
                             name="contact_number_2" id="contact_number_2" required />
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label>
                      PO Number required?
                    </label>

                    <div className="btn-group btn-group-toggle driver-uniform-form-radio-container text-center"
                         data-toggle="buttons">
                      <label className="btn btn-secondary yes-driver-uniform">
                        <input className="form-control form-control-lg"
                               name="subcontractor_po_number"
                               type="radio" value="1" required /> YES
                      </label>
                      <label className="btn btn-secondary no-driver-uniform">
                        <input className="form-control form-control-lg"
                               name="subcontractor_po_number"
                               type="radio" value="0" required /> NO
                      </label>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <label>
                      Access to Cargoes Logistics Portal?
                    </label>

                    <div className="btn-group btn-group-toggle driver-uniform-form-radio-container text-center"
                         data-toggle="buttons">
                      <label className="btn btn-secondary yes-driver-uniform">
                        <input className="form-control form-control-lg"
                               name="subcontractor_access_to_g4"
                               type="radio" value="1" required /> YES
                      </label>
                      <label className="btn btn-secondary no-driver-uniform">
                        <input className="form-control form-control-lg"
                               name="subcontractor_access_to_g4"
                               type="radio" value="0" required /> NO
                      </label>
                    </div>
                  </div>

                  <div className="col-md-12">
                    <div className="form-group">
                      <label htmlFor="payment_terms">Payment Terms</label>
                      <input type="text" className="form-control form-control-lg"
                             name="payment_terms" id="payment_terms" required />
                    </div>
                  </div>

                </div>
                  <hr />

              </div>
              <div className="col-md-6">
                <h3>Home Address</h3>
                <br />
                <div className="form-group address-finder">
                  Address Finder:
                  <div id="home_address_postcode_lookup"></div>
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_house_number_or_name">House Number or Name:</label>
                  <input type="text" name="home_address_house_number_or_name"
                         id="home_address_house_number_or_name" className="form-control form-control-lg"  />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_address_line_1">Address Line 1:</label>
                  <input type="text" name="home_address_address_line_1"
                         id="home_address_address_line_1" className="form-control form-control-lg"  required />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_address_line_2">Address Line 2:</label>
                  <input type="text" name="home_address_address_line_2"
                         id="home_address_address_line_2" className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_address_line_3">Address Line 3:</label>
                  <input type="text" name="home_address_address_line_3"
                         id="home_address_address_line_3" className="form-control form-control-lg" />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_town_city">Town/City:</label>
                  <input type="text" name="home_address_town_city"
                         id="home_address_town_city" className="form-control form-control-lg" required />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_county_area">County/Area</label>
                  <input type="text" name="home_address_county_area"
                         id="home_address_county_area" className="form-control form-control-lg" required />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_country" required>Country:</label>
                  <input type="text" name="home_address_country"
                         id="home_address_country" className="form-control form-control-lg"  required />
                </div>

                <div className="form-group">
                  <label htmlFor="home_address_postcode">Postcode:</label>

                  <input type="text" name="home_address_postcode"
                         id="home_address_postcode" className="form-control form-control-lg" required />

                </div>
              </div>
            </div>
            <div className="text-center">
              <button className="btn btn-lg btn-primary" onClick={this.handleAddNewSubcontractorCreate} type="button"> Add New Subcontractor </button>
            </div>
          </fieldset>
        </form>
      </div>
    );
  }
} 


class CustomersPowerSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      customers: props.customersAll || []
    };
    this.handleChange = this.handleChange.bind(this);

  }
  componentDidMount() {
    let that = this;
    $.ajax({
      url: "/api/v1/portal/customers",
      data: {api_token: window.api_token},
      cache: false
    })
      .done(function(customersJson) {
        that.setState({customers: customersJson});
      });
  }

  handleChange( { option })  {
    this.setState({
      selectedOption: option,
    })
    this.props.handleCustomerSelection(option);
  }

  render() {
    return (
      <PowerSelect
        options={this.state.customers}
        optionLabelPath="name"
        selected={this.state.selectedOption}
        onChange={this.handleChange}
        placeholder="-- select a Customer -- "
        required
      />
    )
  }
}

class CustomerDropDownItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: props.initialValue || 'placeholder',
      customer: props.data
    };

  }

  render() {
    return (
      <option value={this.props.data.id}> {this.props.data.name}</option>
    )
  }
}



if (document.getElementById('react-component-g4-logistics-portal-add-new-subcontractor')) {
  ReactDOM.render(<AddNewSubcontractor />, document.getElementById('react-component-g4-logistics-portal-add-new-subcontractor'));
}
